import React from "react";
import Modal from "./modal";
import { useTranslation } from "react-i18next";
import { FiActivity, FiCheckCircle, FiXCircle } from "react-icons/fi";

export default function DiagnosticModal({ show, onResult, onClose }) {
  const { t } = useTranslation();

  return (
    <Modal show={show} onClose={onClose}>
      <div className="rp-detail-modal">
        <h2 className="rp-modal-title">
          <FiActivity /> {t("reproWheel.diagnosticTitle") || "Diagnostic Oestrus"}
        </h2>
        <div className="rp-diag-actions">
          <button
            className="rp-diag-btn rp-diag-positive"
            onClick={() => onResult("positif")}
          >
            <FiCheckCircle />
            <span>{t("reproWheel.diagnosticPositive") || "Positif"}</span>
          </button>
          <button
            className="rp-diag-btn rp-diag-negative"
            onClick={() => onResult("negatif")}
          >
            <FiXCircle />
            <span>{t("reproWheel.diagnosticNegative") || "Négatif"}</span>
          </button>
        </div>
      </div>
    </Modal>
  );
}
